import { AxiosResponse } from "axios";
import CatchBlockFunction from "../../../../components/hooks/CatchBlockFunction";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import { get, patch, post, putType } from "../../../../utils/request";
import {
  selectFormData,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectToggleLoading,
} from "./selector";

import { categoryValidation } from "../../../../components/Common/Validations";
import { IData } from "../types";
import { actions } from "./slice";

export function* doCreateRequest(action: {
  payload: { callback: () => void };
}) {
  yield delay(500);

  const form: IData = yield select(selectFormData);
  const isValid = categoryValidation(form);
  if (!isValid) {
    return;
  }
  const data = {
    title: form?.title,
    featuredImage: form?.featuredImage,
    status: form?.status,
    sortOrder: form?.sortOrder,
  };
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      post,
      `admin/category/add`,
      data
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action?.payload?.callback);
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetListRequest() {
  yield delay(500);

  try {
    const pageNo: number = yield select(selectPageNo);
    const pageSize: number = yield select(selectPageSize);
    const orderBy: string = yield select(selectOrderBy);
    const orderDir: string = yield select(selectOrderDir);
    const search: string = yield select(selectSearch);
    const buttonLoading: boolean = yield select(selectToggleLoading);
    if (!buttonLoading) {
      yield put(actions.setLoading(true));
    }

    const response: AxiosResponse = yield call(
      get,
      `admin/category/list?pageNo=${pageNo}&pageSize=${pageSize}${
        search.length > 0 ? "&search=" + search : ""
      }${orderBy.length > 0 ? "&orderBy=" + orderBy : ""}${
        orderDir.length > 0 ? "&orderDirection=" + orderDir : ""
      }`
    );
    yield put(actions.setLoading(false));
    yield put(actions.setToggleLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(
      actions.setTotalRow(
        response.data.data.meta ? response.data.data.meta.total : 0
      )
    );
    yield put(actions.setList(response.data.data.results));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    yield put(actions.setToggleLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetByIdRequest(action: { payload: string }) {
  yield delay(500);

  try {
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(
      get,
      `admin/category/get/${
        action.payload !== undefined && action.payload !== null
          ? action.payload
          : ""
      }`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setDataForm(response.data.data));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doUpdateRequest(action: { payload: { callback: any } }) {
  yield delay(500);

  const form: IData = yield select(selectFormData);
  const isValid = categoryValidation(form);
  if (!isValid) {
    return;
  }
  const data = {
    title: form?.title,
    featuredImage: form?.featuredImage,
    status: form?.status,
    sortOrder: form?.sortOrder,
  };
  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield call(
      putType,
      `admin/category/update/${form._id}`,
      data
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action?.payload?.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}

export function* doUpdateStatusRequest(action: {
  payload: { id: string; callback: any };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    yield put(actions.setToggleLoading(true));
    const response: AxiosResponse = yield call(
      patch,
      `admin/category/status/update/${
        action.payload.id !== undefined && action.payload.id !== null
          ? action.payload.id
          : ""
      }`,
      {}
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetAllListRequest() {
  yield delay(500);

  try {
    const response: AxiosResponse = yield call(get, `admin/category/all`);
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setAllList(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* CategoryRepoSaga() {
  yield takeLatest(actions.doCreate, doCreateRequest);
  yield takeLatest(actions.doUpdate, doUpdateRequest);
  yield takeLatest(actions.doGetList, doGetListRequest);
  yield takeLatest(actions.doGetById, doGetByIdRequest);
  yield takeLatest(actions.doUpdateStatus, doUpdateStatusRequest);
  yield takeLatest(actions.doGetAllCategoryList, doGetAllListRequest);
}
